import React from 'react';
import { Button, Form } from 'antd';

function AuthForm({ name, initialValues, submitLabel, onSubmit, children }) {
  return (
    <Form
      className="auth-form"
      name={name}
      onFinish={onSubmit}
      initialValues={initialValues}
    >
      {children}
      <Form.Item className="auth-form__item">
        <Button
          type="primary"
          htmlType="submit"
          className="auth-form__submit w-100"
          size="large"
        >
          {submitLabel}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default AuthForm;
